import { z } from "zod";
import { BIBLE_NOTES_MAX_LENGTH, BIBLE_SETTING_MAX_LENGTH, BIBLE_TONE_MAX_LENGTH, CHARACTER_DESCRIPTION_MAX_LENGTH, CHARACTER_NAME_MAX_LENGTH, LOCATION_DESCRIPTION_MAX_LENGTH, LOCATION_NAME_MAX_LENGTH, } from "../../constants/limits.js";
import { NARRATIVE_MODE_VALUES } from "../../constants/narrative-mode.js";
import { VISUAL_STYLE_VALUES } from "../../constants/visual-style.js";
export const upsertSeriesBibleSchema = z.object({
    visualStyle: z.enum(VISUAL_STYLE_VALUES),
    narrativeMode: z.enum(NARRATIVE_MODE_VALUES),
    tone: z.string().max(BIBLE_TONE_MAX_LENGTH),
    setting: z.string().max(BIBLE_SETTING_MAX_LENGTH),
    povKitNotes: z.string().max(BIBLE_NOTES_MAX_LENGTH).nullable(),
});
export const AdminSeriesBibleSchema = upsertSeriesBibleSchema.extend({
    locked: z.boolean(),
});
export const createCharacterSchema = z.object({
    name: z.string().min(1).max(CHARACTER_NAME_MAX_LENGTH),
    description: z.string().max(CHARACTER_DESCRIPTION_MAX_LENGTH),
    continuityRules: z.string().max(BIBLE_NOTES_MAX_LENGTH).nullable(),
    voiceNotes: z.string().max(BIBLE_NOTES_MAX_LENGTH).nullable(),
});
export const updateCharacterSchema = createCharacterSchema.partial();
export const AdminCharacterSchema = z.object({
    id: z.uuid(),
    name: z.string(),
    description: z.string(),
    continuityRules: z.string().nullable(),
    voiceNotes: z.string().nullable(),
    createdAt: z.string(),
});
export const createLocationSchema = z.object({
    name: z.string().min(1).max(LOCATION_NAME_MAX_LENGTH),
    description: z.string().max(LOCATION_DESCRIPTION_MAX_LENGTH),
    lighting: z.string().max(BIBLE_NOTES_MAX_LENGTH).nullable(),
    palette: z.string().max(BIBLE_NOTES_MAX_LENGTH).nullable(),
    cameraNotes: z.string().max(BIBLE_NOTES_MAX_LENGTH).nullable(),
    ambienceNotes: z.string().max(BIBLE_NOTES_MAX_LENGTH).nullable(),
});
export const updateLocationSchema = createLocationSchema.partial();
export const AdminLocationSchema = z.object({
    id: z.uuid(),
    name: z.string(),
    description: z.string(),
    lighting: z.string().nullable(),
    palette: z.string().nullable(),
    cameraNotes: z.string().nullable(),
    ambienceNotes: z.string().nullable(),
    createdAt: z.string(),
});
